var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQmeeShare = function SvgQmeeShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF38A6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.5 7.334a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5M5.5 13.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5M16.5 20.167a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5M7.875 12.384l6.26 3.649M14.127 5.967 7.875 9.616"
  })));
};
export default SvgQmeeShare;